import { Modal, TextInput, Button, Group } from '@mantine/core';
import { useForm } from '@mantine/form';
import { LoadingButton } from '@mui/lab';
import { useEffect } from 'react';

interface CollectionModalProps {
    opened: boolean;
    onClose: () => void;
    onSubmit: (values: any) => void;
    initialValues?: any;
    isLoading: boolean;
}

export function CollectionModal({ opened, onClose, onSubmit, initialValues, isLoading }: CollectionModalProps) {
    const form = useForm({
        initialValues: {
            name: '',
        },
        validate: {
            name: (value: any) => {
                if (!value?.trim()) return 'Collection name is required';
                if (value.trim().length < 2) return 'Collection name must be at least 2 characters';
                if (value.trim().length > 100) return 'Collection name must be less than 100 characters';
                return null;
            },
        },
    });

    useEffect(() => {
        if (opened) {
            if (initialValues) {
                form.setValues({
                    name: initialValues.Name,
                });
            } else {
                form.reset();
            }
        }
    }, [opened, initialValues]);

    return (
        <Modal
            opened={opened}
            onClose={() => {
                form.reset();
                onClose();
            }}
            title={initialValues ? 'Edit Collection' : 'Add Collection'}
            centered
        >
            <form
                onSubmit={form.onSubmit((values) => {
                    onSubmit(values);
                })}
            >
                <TextInput
                    withAsterisk
                    label={'Collection Name'}
                    placeholder="Enter collection name"
                    key={form.key('name')}
                    {...form.getInputProps('name')}
                    maxLength={100}
                />

                <Group justify="flex-end" mt="md">
                    <Button variant="outline" onClick={onClose} mr="-5px">
                        Cancel
                    </Button>
                    <LoadingButton type="submit" loading={isLoading} variant="contained" color="primary">Save</LoadingButton>
                </Group>
            </form>
        </Modal>
    );
} 